<template>
  <li :class="[singleMode ? 'menu-empty-li' : '', disabled ? 'disabled' : '']">
    <a v-if="!singleMode" :href="link" @click="onClicked" :class="[icon ? 'dropdown-menu-item-icon' : '']"><i v-if="icon" :class="[iconStyle, icon, 'fa-fw']"></i>
      <span v-if="badge" class="badge badge-danger">{{badge}}</span>
      <slot />
    </a>
    <TableActionItem v-if="singleMode" @click="onClicked" :icon="icon" :title="label" :link="link" :buttonSize="buttonSize" />
  </li>
</template>

<style scoped>
.menu-empty-li {
  list-style: none;
  display: block;
  padding: 0;
  margin: 0;
}
.menu-item-single-icon {
  color: #909090;
}
</style>

<script>
export default {
  inject: {
    actionDropMenu: {
      default() {
        return { }
      }
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconStyle: {
      type: String,
      default: 'far'
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: '#'
    },
    buttonSize: {
      type: String,
      default: 'btn-xs'
    },
    badge: String
  },
  data() {
    return {
      singleMode: false
    }
  },
  watch: {
    singleMode(newVal, oldVal) {
      
    }
  },
  mounted() {
    this.registerMenuItem()
  },
  destroyed() {
    this.unregisterMenuItem()
  },
  methods: {
    registerMenuItem() {
      this.actionDropMenu.registerMenuItem && this.actionDropMenu.registerMenuItem(this)
    },
    unregisterMenuItem() {
      this.actionDropMenu.unregisterMenuItem && this.actionDropMenu.unregisterMenuItem(this)
    },
    onClicked(evt) {
      // If no click listener, don't prevent default
      // If we have a link, push that instead of refreshing the page
      if(!this.$listeners || !this.$listeners.click) {
        if(this.link && this.link != '#') {
          evt.preventDefault()

          // If it starts with http, open a new tab
          if(this.link.startsWith('http')) {
            window.open(this.link, '_blank').focus();
            return
          }

          this.$router.push(this.link)
        }
        return
      }
        
      evt.preventDefault()
      this.$emit('click', evt)
    }
  }
}
</script>